module.exports = __webpack_public_path__ + "static/img/zl-a.67dac988.png";